import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import StreamSendMessageButton from 'components/stream-messaging/send-message-button'
import SensitiveInfoWrapper from 'lib/auth/SensitiveInfoWrapper'
import ChatBubble from 'components/material-symbol/icons/ChatBubble'
import { useStyles } from './styles'

const EnrollmentItem = ({ enrollment }) => {
  const classes = useStyles()
  const { student } = enrollment
  const { firstName, lastName } = student
  const { contact } = student
  const studentFullName = `${firstName} ${lastName}`
  const contactFullName = `${contact.firstName} ${contact.lastName}`

  return (
    <Box className={classes.detailRowContent}>
      <Box className={classes.detailCopy}>
        <Typography className={classes.detailPrimary}>
          {firstName} {lastName}
        </Typography>
        {studentFullName !== contactFullName && (
          <Typography className={classes.detailSecondary}>
            Point of Contact: {contactFullName}
          </Typography>
        )}
      </Box>
      <SensitiveInfoWrapper>
        <StreamSendMessageButton
          userIds={[contact.externalId]}
          component={props => (
            <Tooltip title="Message student">
              <IconButton
                {...props}
                aria-label="Message student"
                className={classes.borderedActionButton}
              >
                <ChatBubble fontSize="small" fill={0} />
              </IconButton>
            </Tooltip>
          )}
        />
      </SensitiveInfoWrapper>
    </Box>
  )
}

EnrollmentItem.propTypes = {
  enrollment: PropTypes.object.isRequired,
}

export default EnrollmentItem
